import { IFramework } from '@/framework';
import { GroupRoleType, IGroupLayerProps, LayerType, type ILayerProps } from '@/version-types';
import { type HierarchyMenuItem } from './types';

/**
 * 图层缩略图尺寸
 */
export const THUMBNAIL_SIZE = 40;

/**
 * UI 常量: 普通图层 item 高度
 */
export const ITEM_HEIGHT = 56;

/**
 * UI 常量: 图层 item 底部间距
 */
export const ITEM_MARGIN_BOTTOM_NORMAL = 8;

/**
 * UI 常量: 组图层 item 底部间距
 */
export const ITEM_MARGIN_BOTTOM_GROUPED = 12;

/**
 * UI 常量: 滚动区域最大高度
 */
export const SCROLL_AREA_MAX_HEIGHT = 436;

/**
 * UI 常量: 组图层 item 底部装饰高度
 */
export const GROUP_ITEM_BOTTOM_DECORATION_HEIGHT = 4;

/**
 * 事件集合
 */
export const HIERARCHY_EVENTS = {
    OPEN: 'hierarchy/open',
    LAYER_OPERATION: 'hierarchy/layer-operation',
    SELECT_MANUAL: 'hierarchy/select-manual',
    TOGGLE_AVAILABILITY: 'hierarchy/toggle-availability',
    SET_OBJECT_TO_CENTER: 'hierarchy/set-object-to-center',
};

export const DEFAULT_PREVENT_HIDDEN_TYPES = [LayerType.BACKGROUND_LAYER, LayerType.MAIN_LAYER];

const checkIsPuzzle = (layer: ILayerProps, framework: IFramework) => {
    const parentId = layer.parentId;
    if (!parentId) return false;
    const parentLayer = framework.service.flatLayer.getLayer(parentId);

    if (!parentLayer) return false;
    return (
        parentLayer.layerType === LayerType.GROUP_LAYER &&
        (parentLayer.data as IGroupLayerProps).extension?.role === GroupRoleType.PUZZLE
    );
};

const defaultPredicate = (layer: ILayerProps, framework: IFramework) => {
    if (DEFAULT_PREVENT_HIDDEN_TYPES.includes(layer.layerType)) return false;
    if (checkIsPuzzle(layer, framework)) return false;
    return !layer.lock;
};

const getDefaultHierarchyMenus = (framework: IFramework) => {
    const deleteItem: HierarchyMenuItem = {
        icon: 'TrashCan',
        labelKeyPath: 'plugin.hierarchy.delete', // Q: 这里为什么不直接用 $t(v => v.plugin.hierarchy.delete)？ A: 不能保证编辑器启动前 i18n 已经加载完成
        operation: 'delete',
        predicate: (layer: ILayerProps) => defaultPredicate(layer, framework),
    };

    const duplicateItem: HierarchyMenuItem = {
        icon: 'Duplicate',
        labelKeyPath: 'plugin.hierarchy.duplicate',
        operation: 'duplicate',
        predicate: (layer: ILayerProps) => {
            if (layer.layerType === LayerType.WATERMARK) return false;
            return defaultPredicate(layer, framework);
        },
    };

    return [deleteItem, duplicateItem];
};

export const getDefaultHierarchyConfig = (framework: IFramework) => {
    return {
        onlyShowSortableLayers: false,
        menuItems: getDefaultHierarchyMenus(framework),
        preventHiddenTypes: DEFAULT_PREVENT_HIDDEN_TYPES,
    };
};
